import { UserApi } from 'api-typings/users/users';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    userPendingFunds: UserApi;
  }
}

export const userPendingFundsBackend = {
  fetch: () => ({
    endpoint: `users/0.1/self`,
    params: { balance_details: 1 },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-pending-funds/user-pending-funds.backend.ts